
import React from "react";
import ReactPaginate from "react-paginate";

function Pagination({
  currentPage = 1,
  totalPages = 0,
  onPageChange,
  pageRangeDisplayed = 3,
  marginPagesDisplayed = 1,
}) {
  
  // Agar sirf 1 page hai to pagination hide
  if (totalPages <= 1) {
    return null;
  }

  const handlePageChange = ({ selected }) => {
    // ReactPaginate = 0 based
    // API/Page state = 1 based
    onPageChange(selected + 1);
  };

  return (
    <div className="pagination-wrapper">
      <ReactPaginate
          key={`page-${currentPage}-${totalPages}`} 
        pageCount={totalPages}
        forcePage={currentPage - 1}
        pageRangeDisplayed={pageRangeDisplayed}
        marginPagesDisplayed={marginPagesDisplayed}
        onPageChange={handlePageChange}
        containerClassName="pagination"
        activeClassName="active"
        previousLabel="Previous"
        nextLabel="Next"
        breakLabel="..."
        breakClassName="break-me"
        pageLinkClassName="page-link"
        previousLinkClassName="page-link"
        nextLinkClassName="page-link"
        pageClassName="page-item"
        previousClassName="page-item"
        nextClassName="page-item"
        disabledClassName="disabled"
      />
    </div>
  );
}

export default Pagination;

